import { createContext } from "react";

export const FGV2Context = createContext({});
